import React, { Component, lazy, Suspense } from 'react';
import { Routes, Route, Switch, useHistory } from "react-router-dom";
import Auth from "../../../../Layout/Auth";
import SettingsPage from '../Pages/SettingsPage';
import VariantOptionRoutes from './VariantOptionRoutes';
import MeasurementUnitRoutes from './MeasurementUnitRoutes';
import KitchenDisplayRoutes from './KitchenDisplayRoutes';
import BillPostingSettingsRoutes from './BillPostingSettingsRoutes';

import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

function SettingsRoute() {
    const history = useHistory();
    return (
        <Switch>
            {/* Variant Options Routes */}
            <Route
                path="/:lng/settings/variant-options"
                render={(props) => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <VariantOptionRoutes {...props} />
                        </Suspense>
                    </Auth>
                )}
            />
            
            {/* Measurement Units Routes */}
            <Route
                path="/:lng/settings/measurement-units"
                render={(props) => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <MeasurementUnitRoutes {...props} />
                        </Suspense>
                    </Auth>
                )}
            />

            {/* Kitchen Display Routes */}
            <Route
                path="/:lng/settings/kitchen-displays"
                render={(props) => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <KitchenDisplayRoutes {...props} />
                        </Suspense>
                    </Auth>
                )}
            />
            {/* Bill Posting Settings Routes */}
            <Route
                path="/:lng/settings/bill-posting-settings"
                render={(props) => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <BillPostingSettingsRoutes {...props} />
                        </Suspense>
                    </Auth>
                )}
            />

            {/* Main Settings Page Route - Keep this last as it's a catch-all */}
            <Route
                exact
                path="/:lng/settings/:type?/:next_step?"
                render={(props) => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <SettingsPage history={history} {...props} />
                    </Auth>
                )}
            />

           
        </Switch>
    );
}

export default SettingsRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
